import React from 'react';
import { Switch, Route } from 'react-router-dom';

import Home from '../pages/Home';
//import About from '../pages/About';
import Contact from '../pages/Contact';
import Hosting from '../pages/Hosting';
import PageNotFound from '../pages/PageNotFound'

const MainSwitch = () => (
    <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/about" component={Home} />
        <Route path="/contact" component={Contact} />
        <Route path="/hosting" component={Hosting} />
        <Route path="*" component={PageNotFound} />
    </Switch>
)

export default MainSwitch;